import AbstractDexieClass from "../abstractClasses/AbstractDexieErrorLog";

export default class ConnectionError extends AbstractDexieClass {
  constructor() {
    super("ConnectionError", {
      employee: String,
      company: String,
      team: String,
      route: String,
      href: String,
      hint: String,
      errorString: String,
      timeStamp: Date,
    });
  }
}
